import ThemeCustomization from "./themes"
import { store } from "store"
import { Provider as ReduxProvider } from "react-redux"
import { BrowserRouter } from "react-router-dom"
import { ConfigProvider } from "./providers/AppConfigProvider"
import { ComponentType } from "react"
import AppQueryProvider from "./providers/AppQueryClientProvider"

// fonts
import "assets/fonts/inter/inter.css"

// scroll bar
import "simplebar-react/dist/simplebar.min.css"
import AppAuthProvider from "./providers/AppAuthProvider"
import AppRoutes from "./routes"
import AppNotistackProvider from "./providers/AppNotistackProvider"
import customYupMethods from "@/utils/validators"
import LanguageProvider from "./providers/LanguageProvider"
customYupMethods.useCustomYupValidationMethods()
//import "slick-carousel/slick/slick.css";
//import "slick-carousel/slick/slick-theme.css";

// apex-chart
//import "assets/third-party/apex-chart.css"

function App() {
    return (
        <BrowserRouter>
            <AppRoutes />
        </BrowserRouter>
    )
}

const withProviders = (Component: ComponentType<unknown>) => {
    return function Wrapper() {
        return (
            <AppQueryProvider>
                <ReduxProvider store={store}>
                    <ConfigProvider>
                        <ThemeCustomization>
                            <AppNotistackProvider>
                                <AppAuthProvider>
                                    <LanguageProvider locale={import.meta.env.VITE_LOCALE}>
                                        <Component />
                                    </LanguageProvider>
                                </AppAuthProvider>
                            </AppNotistackProvider>
                        </ThemeCustomization>
                    </ConfigProvider>
                </ReduxProvider>
            </AppQueryProvider>
        )
    }
}

export default withProviders(App)
